module.exports = __webpack_public_path__ + "static/media/NO_GLUTEN.5220239d.svg";